<template>
  <div class="role-page anCore-fill" v-loading="loading">
    <div class="table-responsive">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>角色名称</th>
            <th>权限</th>
          </tr>
        </thead>
        <tbody v-if="roles.length">
          <tr v-for="(row, idx) in roles" :key="row.RoleID">
            <td>{{ idx + 1 }}</td>
            <td>{{ row.RoleName }}</td>
            <td>
              <table v-if="authGroups(row).length" class="table">
                <thead>
                  <tr>
                    <th style="width:130px;">模块</th>
                    <th>功能清单</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="g in authGroups(row)" :key="g.module">
                    <td>{{ g.module }}</td>
                    <td>{{ g.actions }}</td>
                  </tr>
                </tbody>
              </table>
              <span v-else class="text-muted">—</span>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="3">
              <div class="text-center text-muted" style="padding:50px 0;">没有数据信息...</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { loadIvanSyncJson } from '@/utils/ivanSync'

export default {
  name: 'RoleManage',
  data() {
    return {
      loading: false,
      roles: []
    }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const data = await loadIvanSyncJson('roles.json')
        this.roles = Array.isArray(data) ? data : []
      } catch (e) {
        this.$message.error(e.message || '加载角色失败')
      } finally {
        this.loading = false
      }
    },
    authGroups(row) {
      const list = row.AuthorityList || []
      const map = {}
      list.forEach(a => {
        const mod = a.ControllerName || a.ControllerUrl || '—'
        if (!map[mod]) map[mod] = []
        if (a.ActionName) map[mod].push(a.ActionName)
      })
      return Object.keys(map).map(module => ({
        module,
        actions: map[module].join('；')
      }))
    }
  }
}
</script>

<style scoped>
.role-page { height: 100%; overflow: auto; padding: 8px; }
.role-page .table { margin-bottom: 0; }
</style>
